module.exports = __webpack_public_path__ + "media/images/emblems/Eysins-coat_of_arms-27a92e41be466c1bc6ecd834a40fc7dc.svg";